import { CalibrationAssignmentStatus } from '../../../lib/types';
import { toEpochMillis } from '../../../lib/helpers/date.helpers';
import { IRecordCompositeScoreInput } from '../../Score/ManageEvaluations/manage-evaluations.interface';
import { assignmentClipProgress } from './assignment-scoring.utils';

export interface IAssignmentProgress {
  total: number;
  scored: number;
  isCompleted: boolean;
}

export const summarizeAssignment = (
  assignment: ICalibrationAssignment,
  bufferedByKey: { [videoSkillKey: string]: IRecordCompositeScoreInput } = {},
): IAssignmentProgress => ({
  ...assignmentClipProgress(assignment, bufferedByKey),
  isCompleted: assignment.status === CalibrationAssignmentStatus.COMPLETED,
});

// List order: pending first (soonest due first, missing dueAt last), then
// completed (most recently assigned first). Returns a new array.
export const sortAssignmentsForList = (assignments: ICalibrationAssignment[]): ICalibrationAssignment[] => {
  const dueRank = (a: ICalibrationAssignment) => (a.dueAt ? toEpochMillis(a.dueAt) : Number.POSITIVE_INFINITY);
  const assignedRank = (a: ICalibrationAssignment) => (a.assignedAt ? toEpochMillis(a.assignedAt) : 0);

  return [...(assignments || [])].sort((a, b) => {
    const aDone = a.status === CalibrationAssignmentStatus.COMPLETED;
    const bDone = b.status === CalibrationAssignmentStatus.COMPLETED;
    if (aDone !== bDone) return aDone ? 1 : -1;
    // Two missing dueAts are both POSITIVE_INFINITY → Infinity − Infinity = NaN, which
    // breaks the sort contract; collapse any NaN difference to 0 (equal) on both rungs.
    if (!aDone) { const d = dueRank(a) - dueRank(b); return Number.isNaN(d) ? 0 : d; }
    const s = assignedRank(b) - assignedRank(a);
    return Number.isNaN(s) ? 0 : s;
  });
};
